import { Entity, makeClone } from 'gossamer-unified';
import { OrgUnitEvent } from './OrgUnitEvent';
import { Event } from './Event';
import { EVENTS_I_HOST } from './SecurityRules';

export interface OrgUnitEventViewRow {
  id: number;
  org_unit_id: number;
  created_at: string;
  event_id: number;
  title: string;
  start_at: string;
  end_at: string;
  visibility_limit: string;
  flow_option: string;
  main_host_user_id: string;
}

const clone = makeClone();

export const OrgUnitEventView: Entity<OrgUnitEventViewRow> = {
  id: 'OrgUnitEventView',
  title: 'Org Unit Event View',
  service: 'main',
  rowLabel: (row: OrgUnitEventViewRow) => [row.org_unit_id, row.event_id].join(' / '),
  rowLabelDynamic: (row: OrgUnitEventViewRow) => `<lookup:Event:${row.event_id}> / <lookup:OrgUnit:${row.org_unit_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.org_unit_event_view',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['org_unit_id', 'ASC']],
  defaultFilters: [],
  fields: {
    id: clone(OrgUnitEvent.fields.id),
    org_unit_id: clone(OrgUnitEvent.fields.org_unit_id),
    created_at: clone(OrgUnitEvent.fields.created_at),
    event_id: clone(OrgUnitEvent.fields.event_id),
    title: clone(Event.fields.title),
    start_at: clone(Event.fields.start_at),
    end_at: clone(Event.fields.end_at),
    visibility_limit: clone(Event.fields.visibility_limit),
    flow_option: clone(Event.fields.flow_option),
    main_host_user_id: clone(Event.fields.main_host_user_id),
  },
};
